<template>
    <div>
        <img class="information-header-img" src="../../static/image/information/InformationDynamics.png">
        <router-view />
    </div>
</template>

<script>

export default {
  name: 'Information',
  metaInfo: {
    title: '新闻资讯', // set a title
    meta: [{                 // set meta
      name: 'keyWords',
      content: '新闻资讯'
    }],
    link: [{                 // set link
      rel: 'description',
      content: '这是索康的官网的新闻资讯'
    }]
  },
  created() {
    // 创建时执行跳转锚点位置
    this.$nextTick(() => {
      // console.log(findId)
      this.$store.dispatch('method/anchorPoint', 'header')
    })
  },
}
</script>

<style scoped>
    .information-header-img{
        width: 100%;
    }
</style>
